import { ApiState } from '../../utils/requestAction';
import requestReducer from '../requestReducer';
import ProductMeasurement from '../../models/ProductMeasurement';


export interface ProductMeasurementDetailState extends ApiState {
  productMeasurement?: ProductMeasurement
}

export default requestReducer<ProductMeasurementDetailState>('PRODUCTMEASUREMENT_DETAIL')
